(async () => {
  if (typeof window.productHandle === 'undefined') return;
  window.dataLayer = window.dataLayer || [];

  try {
    const productRequestUrls = [
      `${Shopify.routes.root}products/${window.productHandle}.js`,
      `${Shopify.routes.root}products/${window.productHandle}?view=json`,
    ];

    const data = await Promise.all((productRequestUrls.map(async (url) => {
      const resp = await fetch(url);
      return resp.json();
    })));

    const productJson = data[0];
    const metafields = data[1];
    let currentVariant = null;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('variant')) {
      const variantId = parseInt(urlParams.get('variant'), 10);
      currentVariant = productJson.variants.find((variant) => variant.id === variantId);
    }

    window.dataLayer.push({
      event: 'ProductDetail',
      ecommerce: {
        currencyCode: Shopify.currency.active,
        detail: {
          products: [{
            name: productJson.title,
            id: currentVariant ? currentVariant.sku : productJson.sku,
            price: currentVariant ? currentVariant.price / 100 : productJson.price / 100,
            brand: productJson.vendor,
            category: productJson.type,
            dimension1: currentVariant ? currentVariant.title : null,
            dimension2: currentVariant ? currentVariant.id : productJson.variants[0].id,
            dimension3: metafields.scent || "",
            dimension4: metafields.key_ingredient || "",
            dimension5: metafields.skin_type || "",
            dimension6: metafields.hair_type || ""
          }],
        },
      },
    });

    console.log('%cEvent: ProductDetail', 'color: #FF9100');
    console.log(window.dataLayer);
  } catch (err) {
    console.error(err);
  }
})();